
import { defineComponent, PropType } from 'vue'
import { InputEvent, MultiSelectOption } from '@/types/app'
import isEmpty from 'lodash/isEmpty'
import SuccessIcon from '@/components/common/icons/Success-Icon.vue'

export default defineComponent({
  name: 'Multiselect',
  components: {
    SuccessIcon,
  },
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    options: {
      type: Array as PropType<{ [key: string]: string }[]>,
      required: true,
      default() {
        return []
      },
    },
    defaultOptions: {
      type: Array as PropType<{ [key: string]: string }[]>,
      default() {
        return null
      },
    },
    onChange: {
      type: Function,
      default() {
        return () => {
          //
        }
      },
    },
  },
  data() {
    return {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      opts: this.setOptions(this.options as any, this.defaultOptions as any),
      showOptions: false,
      timerOnBlur: 0,
    }
  },
  emits: ['onChange'],
  methods: {
    setOptions(
      options: Array<MultiSelectOption>,
      defaultOptions: Array<MultiSelectOption>,
    ) {
      if (isEmpty(options)) return []
      return options.map((opt: MultiSelectOption) => {
        let tmp = { ...opt, selected: false, show: true }
        if (
          defaultOptions &&
          defaultOptions.find(
            (defOpt: MultiSelectOption) => defOpt.value === opt.value,
          )
        ) {
          tmp.selected = true
        }
        return tmp
      })
    },
    select(key: number) {
      const index = this.opts.findIndex(
        (opt: MultiSelectOption) => opt.value === key,
      )
      this.opts[index].selected = !this.opts[index].selected
      clearInterval(this.timerOnBlur)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const input = this.$refs.searchInput as any
      input.focus()
    },
    change() {
      this.pushSelectedOptions()
    },
    focus() {
      this.showOptions = true
    },
    blur() {
      this.pushSelectedOptions()
      this.timerOnBlur = setTimeout(() => {
        this.showOptions = false
      }, 150)
    },
    pushSelectedOptions() {
      const selectedOptions = this.opts
        .filter((opt: MultiSelectOption) => opt.selected)
        .map((opt: MultiSelectOption) => ({ value: opt.value, text: opt.text }))
      this.$emit('onChange', selectedOptions)
    },
    input(event: InputEvent) {
      const filter = event.target.value
      this.opts = this.opts.map((opt: MultiSelectOption) => {
        opt.show = !(
          opt.text.toUpperCase().indexOf(filter.toUpperCase()) === -1
        )
        return opt
      })
    },
  },
  watch: {
    options(options) {
      this.opts = options.map((option: MultiSelectOption) => {
        const f = this.opts.find(
          (opt: MultiSelectOption) => opt.value === option.value,
        )
        if (f) return { ...f }
        return { ...option, selected: false, show: true }
      })
    },
  },
})
